
const Sizing = {

  optTilt(lat) {
    console.log( Math.round(90 - Math.abs(Number(lat)), 0));
    return Math.round(90 - Math.abs(Number(lat)), 0)
  },

  TotalEnergy(energyItems) {
    console.log("Energy items: ",energyItems)
    let energyArr = []
    let inEffBatteries = 0.10;
    let inEffInverter = 0.10;

    for (let i = 0; i < Object.keys(energyItems).length; i++) {
      let energy = Number(energyItems[i]['power']) * Number(energyItems[i]['hours']) * ( Number(energyItems[i]['voltage']) >= 195 ? 1+inEffInverter : 1 );
      energyArr.push(energy);
    }
    let data = energyArr.reduce((total, amount) => total + amount, 0) * (1+inEffBatteries);
    console.log(data);
    return data;
  },

  numPanels(panelSize, roofMount, maxTemp, positioning, energyItems, worstTiltRad) {
    //collect all function HERE
    //First powerReq
    //third
    const TotalEnergy = (energyItems) => {
      console.log("Energy items: ",energyItems)
      let energyArr = []
      let inEffBatteries = 0.10;
      let inEffInverter = 0.10;

      for (let i = 0; i < Object.keys(energyItems).length; i++) {
        let energy = Number(energyItems[i]['power']) * Number(energyItems[i]['hours']) * ( Number(energyItems[i]['voltage']) >= 195 ? 1+inEffInverter : 1 );
        energyArr.push(energy);
      }
      let data = energyArr.reduce((total, amount) => total + amount, 0) * (1+inEffBatteries);
      console.log(data);
      return data;
    };
    const SolarArray = (positioning) => {
      let arraySize;
      let effDrop = (1 / (Number(positioning) / 5 * 1.1));
      if (!Number(positioning) || Number(positioning) === 0 ) {
        // SOMETHING IS WRONG HERE!!!
        arraySize = TotalEnergy(energyItems) / worstTiltRad
      } else {
        arraySize = TotalEnergy(energyItems) / worstTiltRad / (1 - effDrop)
      }
      console.log("array size after positioning drop: ", arraySize);
      return arraySize;
    };
    const powerReq = (roofMount, maxTemp) => {
      let powerReq;
      const effMPPT = 0.90;
      const tempCoeff =  0.44; // % per degree celsius
      const factMount = roofMount === 'ground' ? 1.2 : 1.4;
      let effTemp = 1 - (Number(maxTemp) * factMount - 25)*tempCoeff/100

      powerReq = SolarArray(positioning) / effMPPT / effTemp
      console.log("Efftemp: ", effTemp)
      console.log("Power req: ", powerReq);

      return powerReq;
    };
    //Second SolarArray

    let num = Math.ceil(powerReq(roofMount, maxTemp) / Number(panelSize), 0);
    console.log("Number of panels: ", num)
    return num;
  },

  battStorage(battVoltage, sysVoltage, backupTime, d_o_d, roofMount, maxTemp, positioning, energyItems, worstTiltRad) {
    const TotalEnergy = (energyItems) => {
      console.log("Energy items: ",energyItems)
      let energyArr = []
      let inEffBatteries = 0.10;
      let inEffInverter = 0.10;

      for (let i = 0; i < Object.keys(energyItems).length; i++) {
        let energy = Number(energyItems[i]['power']) * Number(energyItems[i]['hours']) * ( Number(energyItems[i]['voltage']) >= 195 ? 1+inEffInverter : 1 );
        energyArr.push(energy);
      }
      let data = energyArr.reduce((total, amount) => total + amount, 0) * (1+inEffBatteries);
      console.log(data);
      return data;
    };
    const SolarArray = (positioning) => {
      let arraySize;
      let effDrop = (1 / (Number(positioning) / 5 * 1.1));
      if (!Number(positioning) || Number(positioning) === 0 ) {
        // SOMETHING IS WRONG HERE!!!
        arraySize = TotalEnergy(energyItems) / worstTiltRad
      } else {
        arraySize = TotalEnergy(energyItems) / worstTiltRad / (1 - effDrop)
      }
      console.log("array size after positioning drop: ", arraySize);
      return arraySize;
    };
    const powerReq = (roofMount, maxTemp) => {
      let powerReq;
      const effMPPT = 0.90;
      const tempCoeff =  0.44; // % per degree celsius
      const factMount = roofMount === 'ground' ? 1.2 : 1.4;
      let effTemp = 1 - (Number(maxTemp) * factMount - 25)*tempCoeff/100

      powerReq = SolarArray(positioning) / effMPPT / effTemp
      console.log("Efftemp: ", effTemp)
      console.log("Power req: ", powerReq);

      return powerReq;
    }

    let battStorage = TotalEnergy(energyItems) * backupTime / 24 / (d_o_d/100);
    let battBankAmpH = battStorage / sysVoltage;
    console.log("BAttery bank size: ", battBankAmpH);

    //make some logic for the battery types and quantities
    //battery Ah types shall be collected in an array
    //logic needs to be built for most optimal combination
    // of batter size-voltage-number
    const battSizes12V = [180,160,150,145,134,120,100,90,80,75,70,65,60,55,40,33]
    const battSizes2V = [3000,2500,2000,1500,1200,1000,800,770,600,490,420,350,300,250,200];
    const findSize = (arr) => {
      return arr >= battBankAmpH
    }
    const optSeries = (arr) => {
      return Number((Math.ceil(battBankAmpH / arr) * arr - battBankAmpH).toFixed(0))
    }
    if (battVoltage === '12V') {
      if (battBankAmpH <= Math.max(...battSizes12V)) {
        let battSize = battSizes12V.reverse().find(findSize);
        let numSeries = sysVoltage / 12;
        console.log("Battery size + number of series: ", [battSize, numSeries,1])
        return [battSize, numSeries,1]
      } else {
        console.log("Optimization needed for 12V batteries");
        let best5 = battSizes12V.map(optSeries).slice(0,5);
        let bestIndex = best5.indexOf(Math.min(...best5));
        let battSize = battSizes12V[bestIndex];
        console.log(battSize,sysVoltage/12,Math.ceil(battBankAmpH/battSize));
        return [battSize,sysVoltage/12,Math.ceil(battBankAmpH/battSize)]

      }
    } else {
      if (battBankAmpH <= Math.max(...battSizes2V)) {
        let battSize = battSizes2V.reverse().find(findSize);
        let numSeries = sysVoltage / 2;
        console.log("2V batt bank: ", [battSize, numSeries, 1]);
        return [battSize, numSeries, 1]
      } else {
        let best4 = battSizes2V.map(optSeries).slice(0,4);
        let bestIndex = best4.indexOf(Math.min(...best4));
        let battSize = battSizes2V[bestIndex]
        console.log(battSize,sysVoltage/2,Math.ceil(battBankAmpH/battSize));
        return [battSize,sysVoltage/2,Math.ceil(battBankAmpH/battSize)]
      }
    }

  }

}

//Sizing.TotalEnergy(energyItems);
//Sizing.optTilt(lat);
//Sizing.SolarArray(45)
//Sizing.powerReq('ground', 33);
//Sizing.numPanels("300");

//panelSize, roofMount, maxTemp, positioning, energyItems, worstTiltRad
//let energyItems = [
  //{index: 3, value: "BTS 350 Ericsson", power: "500", voltage: 48, hours: 24,done: false},
  //{index: 2, value: "MW Dishes", power: 230, voltage: 48, hours: "24", done: true},
  //{index: 1, value: "Battery cabinet", power: 2000, voltage: "48", hours: 8, done: true}
//];
//panelSize, roofMount, maxTemp, positioning, energyItems, worstTiltRad
//Sizing.numPanels(300, 'ground', 32, 0, energyItems, 5.23)
//battVoltage, sysVoltage, backupTime, d_o_d, roofMount, maxTemp, positioning, energyItems, worstTiltRad
//Sizing.battStorage('2V',48,24, 75, 'ground', 28,0, energyItems, 5.12);
export default Sizing;



// WEBPACK FOOTER //
// ./src/utils/Sizing.js